// Recommended partners. The affiliate code lives here only: change it once and every placement follows.
// Links carry rel="sponsored" (paid links) wherever they are shown.
// AusProxies: no partner links for now (the Undetectable code below belongs to ProProxies)
export const PARTNERS_ON = process.env.VUE_APP_VUE_NAME !== 'ausproxies';

export const UNDETECTABLE = {
    name: 'Undetectable.io',
    url: 'https://undetectable.io/?r=fJz3Q',
    guideUrl: 'https://undetectable.io/blog/mobile-proxy-setup-antidetect-browser/?r=fJz3Q',
    pricingUrl: 'https://undetectable.io/pricing/?r=fJz3Q',
    faqHash: '#undetectable',   // opens the help-centre question about Undetectable
    page: '/partners',          // the Partners page (sidebar)
};
// hosts whose links in FAQ answers are marked as sponsored
export const PARTNER_HOSTS = ['undetectable.io'];
